import generateTypes from '../utils/generateTypes';

export const GET_MATERIALS = generateTypes('GET_MATERIALS');
export const RESET_MATERIALS = generateTypes('RESET_MATERIALS');
